import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=38005a7b&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=38005a7b&prod&lang=css"
import style1 from "./teacher.vue?vue&type=style&index=1&id=38005a7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38005a7b",
  null
  
)

export default component.exports